import { Injectable }                 from '@angular/core'; 
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'; 
import { SpinnerModalComponent } from 'src/app/components/spinner-modal/spinner-modal.component';
import { NavigationStart, Router } from '@angular/router';

@Injectable()
export class DialogsService {
  public spinnerDialog: any;

  constructor(public dialog: MatDialog, router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Loading overlays belong to the page that opened them.
        this.dialog.openDialogs
          .filter((ref) => ref.componentInstance instanceof SpinnerModalComponent)
          .forEach((ref) => ref.close());
      }
    });
  }

  public confirm() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.hasBackdrop = false;
    this.spinnerDialog = this.dialog.open(SpinnerModalComponent, dialogConfig);
  }

  public closeModal() {
    this.spinnerDialog.close();
    return this.spinnerDialog.afterClosed();
  }
}
